import { render } from "./MyReward.vue?vue&type=template&id=3b235f36"
import script from "./MyReward.vue?vue&type=script&lang=js"
export * from "./MyReward.vue?vue&type=script&lang=js"

import "./MyReward.vue?vue&type=style&index=0&id=3b235f36&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__